import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

const Slider = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8vw;
  width: 85%;
  margin: 0 auto 3rem;

  @media (min-width: 800px) {
    display: none;
  }
`;

const MediaColumn = ({ project }) => (
  <div>
    <Slider>
      {project.images.map((image, index) => (
        <Img
          key={index}
          project={project}
          fluid={image.image.asset.fluid}
          alt={image.alternativeText}
        />
      ))}
    </Slider>
  </div>
);

export default MediaColumn;
